import React from 'react'
import Lottie from 'lottie-react'
import homebotAnimation from '../../../../assets/lottie/homebot.json'
import { defineMessages } from 'react-intl'
import { Text } from '@homebotapp/hb-react-component-catalog'

export interface LoadingPageProps {
  message?: string
}

const MSG = defineMessages({
  loading: {
    id: 'Loading.loading',
    defaultMessage: 'Loading...'
  }
})

const LoadingPage: React.FC<LoadingPageProps> = ({ message = MSG.loading.defaultMessage }) => {
  return (
    <div
      data-qa='testLoading'
      style={{
        height: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100vw',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <div className={`fixed top-0 left-0 right-0 bottom-0 z-50 bg-white`}>
        <Lottie
          animationData={homebotAnimation}
          loop={true}
          autoplay={true}
          style={{ width: '250px', height: '250px' }}
        />
      </div>
      <Text color='neutral-900' textAlign='center' size='xl'>
        {message}
      </Text>
    </div>
  )
}

export default LoadingPage
